import {
  Button,
  Grid,
  Icons,
  Text,
  useToggle,
} from "@pushpress/shared-components";
import { useState } from "react";
import AppointmentCard from "../AppointmentCard/AppointmentCard";
import AppointmentAccessModal from "../AppointmentAccessModal/AppointmentAccessModal";
import { AppointmentCredit, PlanForm } from "../PlanDrawer.types";
import { type Control, useFieldArray, useWatch } from "react-hook-form";

interface AppointmentsSectionProps {
  control: Control<PlanForm>;
}

const AppointmentsSection = (props: AppointmentsSectionProps) => {
  const { control } = props;

  const [modalVisible, modalToggle] = useToggle();

  const [selectedIndex, setSelectedIndex] = useState<number | undefined>(
    undefined,
  );

  const { fields, append, update, remove } = useFieldArray({
    control,
    name: "appointmentCredits",
  });

  const [appointmentCredits] = useWatch({
    control,
    name: ["appointmentCredits"],
  });

  const handleAdd = () => {
    setSelectedIndex(undefined);
    modalToggle.on();
  };

  const handleEdit = (index: number) => {
    setSelectedIndex(index);
    modalToggle.on();
  };

  const handleDelete = () => {
    remove(selectedIndex);
    modalToggle.off();
  };

  const handleConfirm = (appointment: AppointmentCredit) => {
    if (selectedIndex !== undefined) {
      update(selectedIndex, appointment);
    } else {
      append(appointment);
    }
    modalToggle.off();
  };

  const appointmentCreditSelected = appointmentCredits?.[selectedIndex];

  return (
    <>
      <Text
        component="h2"
        variant="heading-5"
        weight="600"
        color="wolf-800"
        className="mt-4"
      >
        Appointments
      </Text>
      <Text variant="body-md" color="wolf-600" className="mt-1">
        Add appointment access
      </Text>
      <div className="my-3">
        {fields.map((field, index) => (
          <AppointmentCard
            key={index}
            appointmentCredit={field}
            onClick={() => handleEdit(index)}
          />
        ))}
      </div>
      <Grid container justifyContent="flex-end" className="mt-3 mb-4">
        <Button
          text="Add"
          buttonType="secondary"
          icon={Icons.Plus}
          iconLocation="left"
          onClick={handleAdd}
        />
      </Grid>
      <AppointmentAccessModal
        visible={modalVisible}
        appointmentCredit={appointmentCreditSelected}
        selectedAppointmentCredits={appointmentCredits}
        onClose={modalToggle.off}
        onConfirm={handleConfirm}
        onDelete={handleDelete}
      />
    </>
  );
};

export default AppointmentsSection;
